// extracted by mini-css-extract-plugin
export var mailAnim = "mail-module--mailAnim--1jdBl";
export var AppLogoSpin = "mail-module--App-logo-spin--3c7Nd";